import type { OrigemDado } from '../tipos';

/**
 * Padrão 3: a origem de cada dado aparece.
 *
 * Cinco marcas fixas, sempre com o mesmo significado em qualquer tela. Você
 * nunca precisa adivinhar se um número foi conferido, estimado ou chutado.
 */
export type TipoMarca = 'ok' | 'est' | 'prem' | 'ia' | 'pend';

const MARCAS: Record<TipoMarca, { emoji: string; rotulo: string; cor: string }> = {
  ok: { emoji: '✅', rotulo: 'Confirmado', cor: 'text-ok bg-ok/12' },
  est: { emoji: '📊', rotulo: 'Estimativa', cor: 'text-est bg-est/12' },
  prem: { emoji: '🧩', rotulo: 'Premissa', cor: 'text-prem bg-prem/12' },
  ia: { emoji: '🤖', rotulo: 'Extraído por IA', cor: 'text-ia bg-ia/12' },
  pend: { emoji: '⚠️', rotulo: 'Pendente de validação', cor: 'text-pend bg-pend/12' },
};

export function Marca({ tipo, comRotulo = false }: { tipo: TipoMarca; comRotulo?: boolean }) {
  const m = MARCAS[tipo];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded px-1 py-0.5 text-xs ${m.cor}`}
      title={m.rotulo}
    >
      <span aria-hidden>{m.emoji}</span>
      {comRotulo ? <span className="font-medium">{m.rotulo}</span> : <span className="sr-only">{m.rotulo}</span>}
    </span>
  );
}

const DE_ORIGEM: Record<OrigemDado, TipoMarca> = {
  MANUAL: 'ok',
  IA: 'ia',
  API: 'ok',
  IMPORTACAO: 'ok',
};

export function MarcaDeOrigem({ origem }: { origem: OrigemDado }) {
  return <Marca tipo={DE_ORIGEM[origem]} />;
}

export function LegendaMarcas() {
  return (
    <div className="flex flex-wrap gap-2">
      {(Object.keys(MARCAS) as TipoMarca[]).map((t) => (
        <Marca key={t} tipo={t} comRotulo />
      ))}
    </div>
  );
}
